<template>
    <main>
        <HeaderTab :title="$t('invoice.mes_reglements')" :icon="['fal', 'file-invoice']">
            <template #actions>
                <div class="d-flex align-items-center" style="gap:0.5rem">
                    <!-- Filtres : visibles uniquement sur desktop (md+) -->
                    <b-form-select
                        v-if="year_options.length > 0"
                        v-model="filter_year"
                        :options="year_options"
                        size="sm"
                        style="width:auto"
                        class="d-none d-md-block"
                    />
                    <b-form-select
                        v-if="client_options.length > 2"
                        v-model="filter_client"
                        :options="client_options"
                        size="sm"
                        style="width:auto;max-width:180px"
                        class="d-none d-md-block"
                    />
                    <b-form-select
                        v-if="author_options.length > 2"
                        v-model="filter_author"
                        :options="author_options"
                        size="sm"
                        style="width:auto;max-width:180px"
                        class="d-none d-md-block"
                    />
                    <b-button
                        variant="primary"
                        size="sm"
                        :disabled="downloading || filtered_invoices.length === 0"
                        @click="downloadAll"
                    >
                        <span class="d-none d-md-inline">{{ $t('invoice.tout_telecharger') }} </span>
                        <font-awesome-icon :icon="['fal', downloading ? 'spinner' : 'download']" :pulse="downloading" />
                    </b-button>
                </div>
            </template>
        </HeaderTab>

        <div id="content">
            <div class="container-fluid">
                <!-- Filtres : visibles uniquement sur mobile -->
                <div v-if="year_options.length > 0 || client_options.length > 2 || author_options.length > 2" class="d-flex d-md-none align-items-center flex-wrap pt-2 pb-1" style="gap:0.5rem">
                    <b-form-select
                        v-if="year_options.length > 0"
                        v-model="filter_year"
                        :options="year_options"
                        size="sm"
                        style="width:auto"
                    />
                    <b-form-select
                        v-if="client_options.length > 2"
                        v-model="filter_client"
                        :options="client_options"
                        size="sm"
                        style="width:auto;max-width:180px"
                    />
                    <b-form-select
                        v-if="author_options.length > 2"
                        v-model="filter_author"
                        :options="author_options"
                        size="sm"
                        style="width:auto;max-width:180px"
                    />
                </div>
                <div class="row">
                    <div class="col-12">
                      
                            <div v-if="busy" class="text-center py-5">
                                <LoadingSpinner />
                            </div>
                            <template v-else>
                                <EmptyState v-if="filtered_invoices.length === 0" />
                                <template v-else>
                                    <!-- Vue cards : mobile uniquement -->
                                    <div class="d-md-none">
                                        <div
                                            v-for="inv in filtered_invoices"
                                            :key="'card-' + inv.invoice_id"
                                            class="border-bottom py-3"
                                        >
                                            <div class="d-flex align-items-start" style="min-width:0">
                                                <div class="flex-fill" style="min-width:0;overflow:hidden">
                                                    <div class="d-flex align-items-baseline mb-1">
                                                        <span class="font-weight-bold mr-2">#{{ inv.invoice_num }}</span>
                                                        <small class="text-muted">{{ inv.invoice_date_formatted }}</small>
                                                    </div>
                                                    <div v-if="inv.horses_label" class="small text-truncate text-muted mb-1" :title="inv.horses_label">{{ inv.horses_label }}</div>
                                                    <div class="d-flex align-items-baseline" style="gap:0.75rem">
                                                        <span class="small">{{ inv.invoice_ttc_formatted }}</span>
                                                        <span
                                                            v-if="inv.duedate_balance > 0"
                                                            class="small font-weight-bold text-danger"
                                                        >{{ $t('invoice.a_regler') }} {{ inv.balance_formatted }}</span>
                                                    </div>
                                                </div>
                                                <div class="ml-2 flex-shrink-0">
                                                    <b-button variant="link" size="sm" class="p-0" @click="downloadOne(inv)">
                                                        <font-awesome-icon :icon="['fal', 'download']" />
                                                    </b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Vue tableau : desktop uniquement -->
                                    <div class="d-none d-md-block table-responsive">
                                        <table class="table table-hover mb-0">
                                            <thead class="small text-muted">
                                                <tr>
                                                    <th class="text-nowrap">{{ $t('table.invoices.invoice_date') }}</th>
                                                    <th>#</th>
                                                    <th>{{ $t('invoice.chevaux') }}</th>
                                                    <th class="text-right text-nowrap">{{ $t('table.invoices.invoice_ttc') }}</th>
                                                    <th class="text-right text-nowrap">{{ $t('invoice.a_regler') }}</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="inv in filtered_invoices" :key="inv.invoice_id">
                                                    <td class="small text-nowrap">{{ inv.invoice_date_formatted }}</td>
                                                    <td class="small text-muted text-nowrap">#{{ inv.invoice_num }}</td>
                                                    <td class="small text-truncate" style="max-width:300px">{{ inv.horses_label }}</td>
                                                    <td class="small text-right text-nowrap">{{ inv.invoice_ttc_formatted }}</td>
                                                    <td class="small text-right text-nowrap" :class="inv.duedate_balance > 0 ? 'text-danger font-weight-bold' : 'text-muted'">
                                                        {{ inv.duedate_balance > 0 ? inv.balance_formatted : '—' }}
                                                    </td>
                                                    <td class="text-right text-nowrap">
                                                        <b-button variant="link" size="sm" class="p-0" @click="downloadOne(inv)">
                                                            {{ $t('invoice.telecharger') }}
                                                            <font-awesome-icon :icon="['fal', 'download']" />
                                                        </b-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                            </template>
             
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script type="text/javascript">
import InvoiceMixin from '@/mixins/Invoice.js'
import Common from 'GroomyRoot/assets/js/common.js'
import Tools from 'GroomyRoot/mixins/Tools.js'

export default {
    name: 'PaymentsAddressed',
    mixins: [InvoiceMixin, Tools],

    data() {
        return {
            all_invoices: [],
            busy: false,
            downloading: false,
            filter_year: null,
            filter_client: null,
            filter_author: null,
        }
    },

    computed: {
        year_options() {
            const years = [...new Set(this.all_invoices.map(inv => inv.invoice_year))].sort((a, b) => b - a)
            return years.map(y => ({ value: y, text: String(y) }))
        },

        client_options() {
            const all = { value: null, text: this.$t('invoice.tous_clients') }
            const names = [...new Set(this.all_invoices.map(inv => inv.tiers_rs))].sort()
            return [all, ...names.map(n => ({ value: n, text: n }))]
        },

        author_options() {
            const all = { value: null, text: this.$t('invoice.tous_emetteurs') }
            const names = [...new Set(this.all_invoices.map(inv => inv.author_rs))].sort()
            return [all, ...names.map(n => ({ value: n, text: n }))]
        },

        filtered_invoices() {
            return this.all_invoices
                .filter(inv => {
                    if (this.filter_year && inv.invoice_year !== this.filter_year) return false
                    if (this.filter_client && inv.tiers_rs !== this.filter_client) return false
                    if (this.filter_author && inv.author_rs !== this.filter_author) return false
                    return true
                })
                .sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date))
        },
    },

    async mounted() {
        this.busy = true
        try {
            const [toPay, sold] = await Promise.all([
                this.getAddressedInvoicesToPay(),
                this.getAddressedInvoicesSold(),
            ])

            // Dédupliquer par invoice_id (préférer l'item avec duedate_balance > 0)
            const byId = new Map()
            for (const item of [...(toPay || []), ...(sold || [])]) {
                const inv = item.invoice
                if (!inv) continue
                const id = inv.invoice_id
                if (!byId.has(id) || (item.duedate_balance > 0 && byId.get(id).duedate_balance <= 0)) {
                    byId.set(id, item)
                }
            }

            // Normaliser les données
            this.all_invoices = await Promise.all([...byId.values()].map(async item => {
                const inv = item.invoice
                const year = parseInt(inv.invoice_date.substring(0, 4))

                // Extraire les noms de juments depuis les lignes de facture (dédupliqués)
                const horses = []
                if (Array.isArray(inv.details)) {
                    for (const d of inv.details) {
                        const nom = d.horse && d.horse.horse_nom
                        if (nom && !horses.includes(nom)) horses.push(nom)
                    }
                }

                return {
                    invoice_id:             inv.invoice_id,
                    invoice_num:            inv.invoice_num,
                    invoice_date:           inv.invoice_date,
                    invoice_year:           year,
                    invoice_date_formatted: this.formatDate(inv.invoice_date),
                    tiers_rs:               inv.tiers.tiers_rs,
                    author_rs:              inv.author.tiers_rs,
                    horses_label:           horses.join(', '),
                    invoice_ttc_formatted:  await Common.priceFormat(inv.invoice_ttc, inv.author.tiers_currency || 'EUR', true),
                    duedate_balance:        item.duedate_balance || 0,
                    balance_formatted:      item.duedate_balance > 0 ? await Common.priceFormat(item.duedate_balance, inv.author.tiers_currency || 'EUR', true) : '',
                }
            }))

            // Filtre année par défaut = année de la dernière facture émise
            if (this.year_options.length > 0) {
                this.filter_year = this.year_options[0].value
            }
        } finally {
            this.busy = false
        }
    },

    methods: {
        downloadAll() {
            if (!this.filtered_invoices.length) return
            this.downloading = true
            this.getAddressedPdfInvoice(this.filtered_invoices.map(inv => ({
                invoice_id:   inv.invoice_id,
                invoice_num:  inv.invoice_num,
                invoice_date: inv.invoice_date,
            })))
            setTimeout(() => { this.downloading = false }, 3000)
        },

        downloadOne(inv) {
            this.getAddressedPdfInvoice([{
                invoice_id:   inv.invoice_id,
                invoice_num:  inv.invoice_num,
                invoice_date: inv.invoice_date,
            }])
        },
    },

    components: {
        HeaderTab:      () => import('@/components/HeaderTab'),
        LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
        EmptyState:     () => import('@/components/EmptyState'),
    },
}
</script>
